import { useState } from "react"
import { useForm } from "react-hook-form"
import TextInput from "@components/forms/TextInput"
import Button from "@components/ui/Button"
import { resetPassword } from "@services/passwordRecoveryService"
import AlertBox from "@components/ui/AlertBox"
import ResetPasswordError from "./components/ResetPasswordError"
import ResetPasswordSuccess from "./components/ResetPasswordSuccess"
import { useParams } from "react-router"

function ResetPasswordPage() {
  const { userId, token } = useParams() // Gets userId and token from URL
  const { register, handleSubmit, formState: { errors, isSubmitting }, setError, clearErrors } = useForm()
  const [status, setStatus] = useState("pending") // pending, success, or error
  const [message, setMessage] = useState("")  

  const onSubmit = async (data) => {
    clearErrors()
    setMessage("")

    // Validate passwords match
    if (data.password !== data.confirmPassword) {
      setError("confirmPassword", { type: "manual", message: "Passwords do not match" })
      return
    }

    try {
      await resetPassword(userId, token, data.password)
      setStatus("success")
      setMessage("Password has been reset successfully.")
    } catch (error) {
      setStatus("error")
      setMessage("Failed to reset password. Please try again.")
    }
  }

  return (
    <div className="min-h-[calc(100vh-100px)] bg-base-200 flex items-center justify-center p-4">
      {status === "success" ? (
        <ResetPasswordSuccess />
      ) : status === "error" ? (
        <ResetPasswordError />
      ) : (
        <div className="card w-full max-w-md bg-base-100 shadow-xl">
          <div className="card-body">
            <h2 className="card-title text-2xl font-bold text-center mx-auto">Reset Password</h2>
            <p className="text-center text-base-content/70 mt-2">Please enter your new password below.</p>

            <form onSubmit={handleSubmit(onSubmit)} className="mt-6 space-y-6">
              {message && <AlertBox message={message} type={status === "error" ? "error" : "success"} />}

              <TextInput
                label="New Password"
                name="password"
                type="password"
                placeholder="New Password"
                register={register}
                errors={errors}
                validationRules={{ required: "Password is required" }}
              />

              <TextInput
                label="Confirm New Password"
                name="confirmPassword"
                type="password"
                placeholder="Confirm New Password"
                register={register}
                errors={errors}
                validationRules={{ required: "Confirm Password is required" }}
              />

              <Button isLoading={isSubmitting} className="w-full">
                {isSubmitting ? "Resetting Password..." : "Reset Password"}
              </Button>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default ResetPasswordPage;